
export enum RoleIdEnum {
    Admin = 1,
    HRManager = 2,
    Employee = 3,
    Manager = 4,
    Guest = 5,
    SuperAdmin = 6
}